import {fetchGuideShareUpdate, Guide} from '@blesk-frontend/api';
import {useMutation, useQueryClient} from '@tanstack/react-query';

/**
 * This mutation hook is used to update the Guide share.
 */
export const useGuideShareUpdateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fetchGuideShareUpdate,
    onSuccess(data) {
      queryClient.setQueryData<Guide>(['guides', {id: data.guideId}], (old) => {
        if (!old) {
          return old;
        }
        return {
          ...old,
          share: data,
        };
      });
    },
  });
};
